import {
    HandoffClient,
    HandoffQueryResult
} from "../types.ts";

const poolIdPattern = /^[\w-]+_[0-9A-Za-z]+$/;
const clientIdPattern = /^[0-9a-z]+$/;

export const INVALID_REQUEST_MESSAGE = 'This sign-in link is invalid or incomplete. Return to the application and try again.';

const parseClient = (entry: string): HandoffClient | null => {
    const parts = entry.split(':');
    if (parts.length !== 3) {
        return null;
    }
    const [poolId, appClientId, dedicatedClientId] = parts;
    if (!poolIdPattern.test(poolId) || !clientIdPattern.test(appClientId) || !clientIdPattern.test(dedicatedClientId)) {
        return null;
    }
    return {poolId, appClientId, dedicatedClientId};
};

export const parseHandoffQuery = (params: URLSearchParams): HandoffQueryResult => {
    const request = params.get('request');
    const clientsParam = params.get('clients');

    if (!request || !clientsParam) {
        return {ok: false, error: INVALID_REQUEST_MESSAGE};
    }

    const clients: HandoffClient[] = [];
    for (const entry of clientsParam.split(',')) {
        const client = parseClient(entry);
        if (client === null) {
            return {ok: false, error: INVALID_REQUEST_MESSAGE};
        }
        clients.push(client);
    }

    return {ok: true, value: {request, clients}};
};
